// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {inject, Injectable} from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AccountService} from "../services/account.service";
import {AppScope} from "../services/app_scope.service";


@Injectable()
export class ActiveAccountInterceptor implements HttpInterceptor {


  constructor(private accountService: AccountService, private appScope: AppScope) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const activeAccount = this.appScope.active_account_id;

    // Clone the request and add a custom header with the active account
    if (activeAccount) {
      request = request.clone({
        setHeaders: {
          'X-Active-Account': activeAccount
        }
      });
    }

    return next.handle(request);
  }
}
